
import {
  fetchSupportPoolsTypes,
  fetchMessagesTypes,
  sendMessageTypes,
  acceptSupportTypes,
  resolveSupportTypes,
  unresolveSupportTypes,
  SELECT_SUPPORT_POOL_USER,
  SET_LAST_MESSAGES,
  SUBSCRIBE_TO_MESSAGES,
} from './action_types';

import {
  FETCH_CUSTOMER_SUPPORT_POOLS_QUERY,
  FETCH_CUSTOMER_SUPPORT_MESSAGES_QUERY,
  SEND_MESSAGE_MUTATION,
  ACCEPT_SUPPORT_MUTATION,
  RESOLVE_SUPPORT_MUTATION,
  UNRESOLVE_SUPPORT_MUTATION,
  SUBSCRIBE_TO_MESSAGES_SUBSCRIPTION,
} from './api';

import { makeQuery, makeMutation, makeSubscription } from '../../config/client';

export const fetchCustomerSupportPools = variables => makeQuery(variables)(
  fetchSupportPoolsTypes,
  FETCH_CUSTOMER_SUPPORT_POOLS_QUERY
);

export const fetchMessages = variables => makeQuery(variables)(
  fetchMessagesTypes,
  FETCH_CUSTOMER_SUPPORT_MESSAGES_QUERY
);

export const sendMessage = variables => makeMutation({ variables })(
  sendMessageTypes,
  SEND_MESSAGE_MUTATION
);

export const acceptSupport = variables => makeMutation({ variables })(
  acceptSupportTypes,
  ACCEPT_SUPPORT_MUTATION
);

export const resolveSupport = variables => makeMutation({ variables })(
  resolveSupportTypes,
  RESOLVE_SUPPORT_MUTATION
);

export const unresolveSupport = variables => makeMutation({ variables })(
  unresolveSupportTypes,
  UNRESOLVE_SUPPORT_MUTATION
);

export const selectSupportPoolUser = payload => ({ type: SELECT_SUPPORT_POOL_USER, payload });
export const setLastMessages = payload => ({ type: SET_LAST_MESSAGES, payload });

export const subscribeToMessages = variables => makeSubscription({
  variables,
  name: 'customerSupportAdded',
})(
  SUBSCRIBE_TO_MESSAGES,
  SUBSCRIBE_TO_MESSAGES_SUBSCRIPTION
);



// WEBPACK FOOTER //
// ./src/modules/messages/actions.js